export default __webpack_public_path__ + "static/media/img-55.3a8d4d93.jpg";